import { useIntl } from 'react-intl';

import { CheckboxField } from '@/components/CheckboxField';
import { Flex } from '@/components/Flex';
import { Typography } from '@/components/Typography';
import { commonMessages } from '@/messages/common';
import {
  AccountCreationConfirmationNote,
  formMessages,
  PersonalDataPolicy,
  RevokeConsent,
} from '@/messages/forms';

import * as S from './AccountRegisterCheckbox.styles';

export interface AccountRegisterCheckboxProps {
  action: string;
  disabled?: boolean;
  termsOfUse?: string;
}

export const AccountRegisterCheckbox = ({
  action,
  disabled,
  termsOfUse,
}: AccountRegisterCheckboxProps) => {
  const { formatMessage } = useIntl();
  return (
    <S.Wrapper flexDirection='column' gridGap='s075'>
      <CheckboxField
        data-testid='checkboxNewsletterConsent'
        disabled={disabled}
        marginLeft={true}
        name='newsletterConsent'
      >
        <Flex flexDirection='column' gridGap='s075'>
          <Typography data-testid='AccountRegisterCheckbox-Text-NewsletterConsent'>
            {formatMessage(formMessages.newsletterConsent)}
          </Typography>
          <Typography data-testid='AccountRegisterCheckbox-Text-RevokeConsent'>
            {RevokeConsent}
          </Typography>
        </Flex>
      </CheckboxField>
      <S.SpacerBottom />
      <Flex flexDirection='column' gridGap='s075' pl={4}>
        <Typography data-testid='AccountRegisterCheckbox-Text-PersonalDataPolicy'>
          {PersonalDataPolicy}
        </Typography>
        <Typography data-testid='AccountRegisterCheckbox-Text-AccountCreationConfirmationNote'>
          {AccountCreationConfirmationNote(
            action,
            termsOfUse ?? formatMessage(commonMessages.breitlingTermsOfUse),
          )}
        </Typography>
      </Flex>
    </S.Wrapper>
  );
};
